import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { Caixa } from "../pages/Caixa/index";
import { NotasFiscais } from "../pages/NotasFiscais";
import { RelatorioCaixaDiarioFinanceiro } from "../pages/RelatorioCaixaDiarioFinanceiro";
import { LancamentoContas } from "../pages/LancamentoContas";
import { RelatorioContasMensais } from "../pages/RelatorioContasMensais";
import { RelatorioItensMaisVendidos } from "../pages/RelatorioItensMaisVendidos";
import { RelatorioCombosMaisVendidos } from "../pages/RelatorioCombosMaisVendidos";
import { RelatorioConciliacaoPagamentos } from "../pages/RelatorioConciliacaoPagamentos";
import { Layout } from "../../core/components/Layout";

interface IFinanceiroRoutesProps {
    autenticado: boolean;
}

export const FinanceiroRoutes = ({ autenticado }: IFinanceiroRoutesProps) => {
    return (
        <Routes>
            <Route element={
                <Layout titulo="Financeiro">
                    <PrivateRoutes
                        autenticado={autenticado}
                    />
                </Layout>}>
                <Route path="/caixa" element={<Caixa />} />
                <Route path="/contas" element={<LancamentoContas />} />
                <Route path="/relatorios/caixa-diario" element={<RelatorioCaixaDiarioFinanceiro />} />
                <Route path="/relatorios/contas-mensais" element={<RelatorioContasMensais />} />
                <Route path="/relatorios/itens-vendidos" element={<RelatorioItensMaisVendidos />} />
                <Route path="/relatorios/combos-vendidos" element={<RelatorioCombosMaisVendidos />} />
                <Route path="/relatorios/conciliacao-pagamentos" element={<RelatorioConciliacaoPagamentos />} />
                <Route path="/contabilidade/nfce" element={<NotasFiscais />} />
                <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
            </Route>
        </Routes>
    );
}
